import React, {useEffect} from "react";
import styled from "@emotion/styled/macro";
import { 
    Box,
    Divider,
    Slide
} from "@mui/material";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import CallToAction from "./CallToAction";
import PrinciplesSummary from "./PrinciplesSummary";
import Testimonials from "./Testimonials";

const StyledBox = styled(Box)`
    width: 100%;
    height: 100%;
    min-width: 200px;
    background-color: white;
    overflow: hidden;
`;

const LandingPage = ({testimonialImagesPreloaded}) => {
    let history = useHistory();

    useEffect(() => {
        if(history.action !== "POP"){
            window.scrollTo({
                top: 0
            });
        }
    }, [history]);

    return (
        <Slide direction={history.action === "POP" ? "right" : "left"} in mountOnEnter unmountOnExit>
            <StyledBox>
                <CallToAction />
                <Divider orientation="horizontal" flexItem variant="middle"/>
                <PrinciplesSummary />
                <Divider orientation="horizontal" flexItem variant="middle"/>
                <Testimonials imagesPreloaded={testimonialImagesPreloaded}/>
            </StyledBox>
        </Slide> 
    );
}

export default LandingPage;